import "./hash";
export class Evento {
    constructor(pk, stringa_aaaa_mm_gg, orario, titolo, v, descr) {
        this.titolo = "";
        this.link_videochat = Videochiamata.JITSI;
        this.link_video_generato = "";
        this.descrizione = "Un po' di compagnia? Ti aspettiamo";
        this.attivita_previste = [];
        this.pk = pk;
        if (stringa_aaaa_mm_gg == null) {
            return;
        }
        let yma = stringa_aaaa_mm_gg.split("-");
        let hhmm = orario.split(":");
        this.data = new Date(Number(yma[0]), Number(yma[1]) - 1, Number(yma[2]), Number(hhmm[0]), Number(hhmm[1]));
        this.titolo = titolo;
        if (v) {
            this.link_videochat = v;
        }
        if (descr) {
            this.descrizione = descr;
        }
    }
    da_json(ogg) {
        let yma = ogg.data.split("-");
        let hhmm = ogg.ora.split(":");
        this.data = new Date(Date.UTC(Number(yma[0]), Number(yma[1]) - 1, Number(yma[2]), Number(hhmm[0]), Number(hhmm[1])));
        this.titolo = ogg.titolo;
        this.descrizione = ogg.descrizione;
        this.link_videochat = ogg.link_videochat || Videochiamata.JITSI;
        this.attivita_previste = ogg.attivita_previste || [];
        this.pk = ogg.pk;
        this.link_video_generato = ogg.link_video_generato;
    }
    fornitore_chiamata(f) {
        this.link_videochat = f;
    }
    get_link_videochat() {
        return this.link_video_generato;
    }
    get_attivita_previste() {
        return this.attivita_previste;
    }
    data_dd_mm_yyyy() {
        let gg = this.data.getDate();
        let mm = this.data.getMonth() + 1;
        let aaaa = this.data.getFullYear();
        return `${gg}/${mm}/${aaaa}`;
    }
    data_yyyy_mm_dd() {
        let gg = this.data.getDate();
        let mm = this.data.getMonth() + 1;
        let aaaa = this.data.getFullYear();
        return `${aaaa}_${mm}_${gg}`;
    }
    data_hh_mm() {
        return String(this.data.getHours()).padStart(2, '0') + ":" + String(this.data.getMinutes()).padStart(2, '0');
    }
    get_giorno_settimana() {
        let giorni = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
        return giorni[this.data.getDay()];
    }
    get_stato_tempo_evento() {
        const millis_a_ora = 60 * 60 * 1000;
        let d2 = new Date();
        let d1 = this.data;
        const ore_durata = 5;
        //Usato 
        //1 se d1 giorno dopo d2
        //0 se d1 stesso di d2
        //-1 se d1 prima di d2
        if ((d1.getTime() - d2.getTime() < millis_a_ora)
            &&
                (d2.getTime() - d1.getTime() < millis_a_ora * ore_durata)) {
            return StatoTempoEvento.PRESENTE;
        }
        else {
            if (d1.getTime() - d2.getTime() > 0) {
                return StatoTempoEvento.FUTURO;
            }
            else {
                return StatoTempoEvento.PASSATO;
            }
        }
    }
}
export var Videochiamata;
(function (Videochiamata) {
    Videochiamata[Videochiamata["JITSI"] = 0] = "JITSI";
    Videochiamata[Videochiamata["CAMUS"] = 1] = "CAMUS";
    Videochiamata[Videochiamata["OPEN_MEET_GARR"] = 2] = "OPEN_MEET_GARR";
})(Videochiamata || (Videochiamata = {}));
export var StatoTempoEvento;
(function (StatoTempoEvento) {
    StatoTempoEvento[StatoTempoEvento["PASSATO"] = 0] = "PASSATO";
    StatoTempoEvento[StatoTempoEvento["PRESENTE"] = 1] = "PRESENTE";
    StatoTempoEvento[StatoTempoEvento["FUTURO"] = 2] = "FUTURO";
})(StatoTempoEvento || (StatoTempoEvento = {}));
